import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './AppRouter';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);
root.render(<React.StrictMode data-id="element-5683" data-mp="269aj08uokw3q">
    <AppRouter data-id="element-5684" data-mp="269kda8mrdpf8" />
  </React.StrictMode>);